module.exports = __webpack_public_path__ + "img/横店体育@2x.04e156ea.png";